import { render, staticRenderFns } from "./ReviewDingpanAuction.vue?vue&type=template&id=b50061ca&scoped=true"
import script from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
export * from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
import style0 from "./ReviewDingpanAuction.vue?vue&type=style&index=0&id=b50061ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50061ca",
  null
  
)

export default component.exports